import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-layout`,
};

const strings = {
    BREAKPOINT: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
};

export { cssClasses, strings };